export default __webpack_public_path__ + "static/media/Accountability_Sign.4557968e.png";